module.exports = __webpack_public_path__ + "img/usuarios_1.9d7cd897.svg";